/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { WhatsAppTemplateSyncPathParams, WhatsAppTemplateSyncResponse } from '../types/WhatsAppTemplateSync'

/**
 * POST /organisations/:organisationId/whatsapp-templates/sync
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::sync
 */
export async function whatsAppTemplateSync(
	organisationId: WhatsAppTemplateSyncPathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppTemplateSyncResponse>> {
	return axiosInstance.post(`/organisations/${organisationId}/whatsapp-templates/sync`, undefined, config)
}
